import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Feature from '../components/feature/feature_body';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Features", "feature/feature_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Features || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Feature />
    </div>
  );
};

export default Page;